import getConfig from "./getConfig";

export default function isDev() {
  return getConfig("MY_WORKS_ENVIRONMENT") === 'development';
}
